import React from "react";
import { useSelector } from "react-redux";
import MyPromoCodeCard from "../../componet/my-promo-code-card";
import { motion } from "framer-motion";

const ReferralCodePage: React.FC = () => {
  const userData = useSelector((state: any) => state.user.userData);
  const userId = userData?.id;

  return (
    <div className="min-h-screen bg-[#F8FAFB] p-4 lg:p-10">
      <div className="max-w-[1200px] mx-auto">
        
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-6 mb-12">
          <motion.div 
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
          >
            <div className="flex items-center gap-3 mb-2">
               <div className="w-8 h-1 bg-primary rounded-full"></div>
               <span className="text-[10px] font-black text-primary uppercase tracking-[0.4em]">Programme de Parrainage</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-black text-title tracking-tighter uppercase italic leading-none">
              Code Promo <span className="text-primary italic">Personnel</span>
            </h1>
          </motion.div>
          
          <motion.div 
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            className="hidden md:flex items-center gap-4 bg-white/80 backdrop-blur-md p-4 rounded-3xl border border-white shadow-sm"
          >
             <div className="w-12 h-12 rounded-2xl bg-emerald-50 text-emerald-500 flex items-center justify-center text-xl">
                ✨
             </div>
             <div>
                <p className="text-[10px] font-black text-title uppercase tracking-widest leading-none mb-1">Programme de Parrainage</p>
                <p className="text-[9px] font-bold text-text/40 uppercase tracking-widest leading-none">Invitez & Gagnez des bonus</p>
             </div>
          </motion.div>
        </div>

        {/* Content Area */}
        <div className="flex justify-center">
          <MyPromoCodeCard userId={userId} />
        </div>

      </div>
    </div>
  );
};

export default ReferralCodePage;
